// Helper function to start timeout
const startTimeout = (state) => {
    // Clear existing timeout
    if (state.timeoutId) {
        clearTimeout(state.timeoutId);
        state.timeoutId = null;
    }

    // Only start timeout if notification exists and doesn't have focus
    if (state.notification && !state.hasFocus) {
        state.timeoutId = setTimeout(() => {
            if (!state.hasFocus) {
                state.notification = null;
                state.timeoutId = null;
            }
        }, 5000);
    }
};

const state = {
    notification: null, // { item, providerId, itemIndex }
    timeoutId: null,
    hasFocus: false, // Whether the popup has focus
    closeTimeoutId: null, // Timer for closing when clicking outside
};

const mutations = {
    showNotification(state, { item, providerId, itemIndex }) {
        // Clear existing timeout
        if (state.timeoutId) {
            clearTimeout(state.timeoutId);
            state.timeoutId = null;
        }

        // Cancel close timer if a new item is added
        if (state.closeTimeoutId) {
            clearTimeout(state.closeTimeoutId);
            state.closeTimeoutId = null;
        }

        // Set new notification
        state.notification = {
            item,
            providerId,
            itemIndex,
        };
        state.hasFocus = false;

        // Set timeout to hide after 5 seconds (only if no focus)
        startTimeout(state);
    },
    hideNotification(state) {
        if (state.timeoutId) {
            clearTimeout(state.timeoutId);
            state.timeoutId = null;
        }
        if (state.closeTimeoutId) {
            clearTimeout(state.closeTimeoutId);
            state.closeTimeoutId = null;
        }
        state.notification = null;
        state.hasFocus = false;
    },
    startCloseTimer(state, delay = 2000) {
        // Clear existing close timer
        if (state.closeTimeoutId) {
            clearTimeout(state.closeTimeoutId);
            state.closeTimeoutId = null;
        }

        // Start new close timer
        state.closeTimeoutId = setTimeout(() => {
            state.notification = null;
            state.closeTimeoutId = null;
            // Also clear the main timeout if it exists
            if (state.timeoutId) {
                clearTimeout(state.timeoutId);
                state.timeoutId = null;
            }
        }, delay);
    },
    cancelCloseTimer(state) {
        if (state.closeTimeoutId) {
            clearTimeout(state.closeTimeoutId);
            state.closeTimeoutId = null;
        }
    },
    updateNotificationQuantity(state, quantity) {
        if (state.notification) {
            state.notification.item = {
                ...state.notification.item,
                quantity,
            };
        }
    },
    setFocus(state, hasFocus) {
        state.hasFocus = hasFocus;
        if (hasFocus) {
            // Clear timeout when gaining focus
            if (state.timeoutId) {
                clearTimeout(state.timeoutId);
                state.timeoutId = null;
            }
        } else {
            // Start timeout when losing focus
            startTimeout(state);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};

